import { Service } from '../types/service';
import { colors } from '../styles/theme';

export const services: Service[] = [
  {
    iconName: "Palette",
    title: "Canva Pro",
    description: "Accès premium à Canva Pro pour créer des designs professionnels",
    highlight: "Gratuit",
    color: colors.secondary,
    link: "/services/canva-pro"
  },
  {
    iconName: "Globe",
    title: "Hébergement Web",
    description: "Hébergement gratuit pour vos projets web étudiants",
    highlight: "Gratuit",
    color: colors.tertiary,
    link: "/services/hebergement"
  },
  {
    iconName: "Terminal",
    title: "Codex / Claude Code",
    description: "Un abonnement Plus standard pour coder et avancer sur vos projets",
    highlight: "Gratuit",
    color: colors.primary,
    link: "/services/codex-claude-code"
  },
  {
    iconName: "Code",
    title: "Serveur privé virtuel",
    description: "Un VPS adapté à vos projets étudiants, 24h/24 7J/7 !",
    highlight: "Gratuit",
    color: colors.accent2,
    link: "/services/vps"
  },
  {
    iconName: "Laptop",
    title: "Office 365",
    description: "Accès aux logiciels de la suite Office 365 pour vos études",
    highlight: "Gratuit",
    color: colors.accent3,
    link: "/services/logiciels"
  },
  {
    iconName: "Mails",
    title: "Messagerie",
    description: "Un serveur de messagerie adapté à la vie étudiante",
    highlight: "Gratuit",
    color: colors.primary,
    link: "/services/mail"
  }
];
